import { NoveltyByBrand } from "./CollectionModel";

export class CollectionsBrandModalInfo {
  show: boolean = false;
  collectionId: string = '';
  collectionName: string = '';
  collectionBrands: NoveltyByBrand[];
}